import { rgba } from 'polished';

import type { ColorAliasesKeys, ColorKeys, Colors } from './types/colors';

const generateColorAlphas = (color: ColorKeys, alphas: number[]) =>
  alphas.forEach((value) => {
    const key = `${color}Alpha${value}` as ColorAliasesKeys;
    colors[key] = rgba(colors[color], value / 100);
  });

const defaultColors = {
  defaultAdd1: '#292929',
  defaultAdd2: '#525252',
  defaultAdd3: '#7A7A7A',
  defaultAdd4: '#A3A3A3',
  defaultAdd5: '#D5D5D5',
  defaultAdd6: '#F5F5F5',
  primarySub2: '#E6AD14',
  primarySub1: '#E6AD14',
  primaryAdd1: '#FFE047',
  primaryAdd2: '#488877',
  primaryAdd3: '#6CA08C',
  primaryAdd4: '#91B8A3',
  primaryAdd5: '#B5D0BD',
  primaryAdd6: '#E8E8E8',
  accentSub2: '#7C1B00',
  accentSub1: '#B02D00',
  accent: '#DD4200',
  accentAdd1: '#E25124',
  accentAdd2: '#E76348',
  accentAdd3: '#EB7A6C',
  accentAdd4: '#F09591',
  accentAdd5: '#F5B5B6',
  accentAdd6: '#FAD9DC',
  blackOlive: '#101820',
  primary: '#FFC62D',
  primaryLight: '#fbd157',
  primaryLightAdd2: '#FFC62D1A',
  primaryDisabled: '#FFEDC5',
  primaryBlue: '#0E2240',
  primaryDark: '#072C54',
  default: '#000000',
  black: '#000000',
  white: '#FFFFFF',
  secondary: '#111820',
  secondaryGrey: '#77777A',
  tertiaryGrey: '#EAEAEA',
  quaternaryGrey: '#E3E3E3',
  quinaryGrey: '#E5E5E5',
  mediumGrey: '#EBEBEB',
  disableGrey: '#F7F7F7',
  lightGrey: '#FAFAFA',
  secondaryLightGrey: '#F9F9F9',
  tertiaryLightGrey: '#F1F1F1',
  lightGray: '#D3D3D3',
  paleGray: '#C9C9C9',
  goldenRod: '#FFC72C',
  charcoalGray: '#76787B',
  darkGrey: '#414141',
  inputGrey: '#98989a',
  borderGrey: '#d7d7d7',
  success: '#128E15',
  successLight: '#87D630',
  valid: '#128E0D',
  warning: '#FF9300',
  error: '#F7491D',
  errorLight: '#E98894',
  darkError: '#D52B1E',
  shadow: '#0000003D',
  shadow2: '#00000029',
  navyBlue: '#07213F',
  navyBlueSub1: '#072C54',
  navyBlueSub2: '#204165',
  transparent: 'transparent',
  almostBlack: '#09091A',
  feedbackHighLight: '#FFF8E0',
  feedbackError: '#DC6B4E',
  textLightGrey: '#76787b',
  translucentBlack: '#333333',
  quoteGrey: '#555',
  codeRed: '#c7254e',
  heading: '#FFC62D',
};

const colors: Colors = {
  ...defaultColors,
  destructive: defaultColors.accent,
  destructiveAdd1: defaultColors.accentAdd1,
  destructiveAdd2: defaultColors.accentAdd2,
  destructiveAdd3: defaultColors.accentAdd3,
  destructiveAdd4: defaultColors.accentAdd4,
  destructiveAdd5: defaultColors.accentAdd5,
  destructiveAdd6: defaultColors.accentAdd6,
  destructiveSub2: defaultColors.accentSub2,
  destructiveSub1: defaultColors.accentSub1,
  defaultInverted: defaultColors.white,
  primaryInverted: defaultColors.primaryAdd6,
};

const alphas = [64, 48, 32, 20, 12, 8, 4];

generateColorAlphas('default', alphas);
generateColorAlphas('primary', alphas);
generateColorAlphas('accent', alphas);
generateColorAlphas('destructive', alphas);
generateColorAlphas('white', [40, 32, 24, 16, 12]);
generateColorAlphas('defaultInverted', [40, 32, 24, 16, 12]);
generateColorAlphas('secondaryGrey', [80, 64, 48, 32]);
generateColorAlphas('feedbackError', [20]);

export { colors };
